function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOvoLogo = function SvgOvoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 811 811",
    focusable: "false",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "BASE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M684.94 573.24c-89.16 0-163.3-50.56-177.35-136.59l-50.91 131.41h-100L306 437.42C291.67 523 217.73 573.24 128.81 573.24c-7 0-13.87-.34-20.65-1L172 810.52l638.17-171-24.57-91.69c-28.75 16.59-63.38 25.41-100.66 25.41M624.16 408.13c0 37.07 25 62.51 60.78 62.51s60.8-25.44 60.8-62.51a72 72 0 0 0-1.54-14.73l-2.13-8c-7.92-23.56-28.29-40.66-57.13-40.66-37.5.01-60.78 28.9-60.78 63.39M189.61 408.13c0-34.49-23.29-63.38-60.8-63.38S68 373.64 68 408.13c0 37.07 25 62.51 60.8 62.51s60.81-25.44 60.81-62.51M242.35 273l-11.61-30h123.32l43.11 147.88 9.42 33.33s4.83-17.38 9.55-33.33L459.27 243h123.32l-11.76 30.38c31.11-22.85 70.92-35.55 114.11-35.55 6 0 11.93.26 17.76.73l-63.54-237L1 172.47l25 93.33c29.2-18 64.67-28 102.79-28 42.95.04 82.51 12.6 113.56 35.2",
    style: {
      fill: "#0a9828"
    }
  })));
};
export default SvgOvoLogo;